const elements = document.body.querySelectorAll('.mb-tss');
elements.forEach(element => {
  const errorElement = element.querySelector('.mb-tss-error') as HTMLElement;

  const labelElements = element.querySelectorAll('.mb-tss-content');
  labelElements.forEach((labelElement, index) => {
    let boxNum = 0;
    labelElement.addEventListener('click', event => {
      boxNum = index;
      element.classList.add('is-enable');
      errorElement.classList.remove('is-active');

      const inputElement = labelElement.querySelector('.mb-tss-checkbox-input') as HTMLInputElement;
      inputElement.addEventListener('click', event => event.stopPropagation());

      const fee = Number(labelElement.getAttribute('data-fee'));
      const reduction = Number(labelElement.getAttribute('data-reduction'));
      const result = reduction - fee;
      const displayElement = element.querySelector('.mb-tss-display-content') as HTMLElement;
      displayElement.textContent = fee.toLocaleString();
      const itemFee = element.querySelector('.item-fee') as HTMLElement;
      const itemreduction = element.querySelector('.item-reduction') as HTMLElement;
      itemFee.textContent = '-' + fee.toLocaleString();
      itemreduction.textContent = reduction.toLocaleString();
      const displayResultElement = element.querySelector('.mb-tss-display-result-content') as HTMLElement;
      displayResultElement.textContent = result.toLocaleString();

      const resultTextElements = element.querySelectorAll('.mb-tss-result-text');
      resultTextElements.forEach(resultTextElement => {
        resultTextElement.classList.remove('is-active');
        const number = Number(resultTextElement.getAttribute('data-number'));
        if (boxNum === number) {
          resultTextElement.classList.add('is-active');
        }
      });
    });
  });

  // 実行btn
  const executeBtnbElement = element.querySelector('.mb-tss-footer-button') as HTMLButtonElement;
  executeBtnbElement.addEventListener('click', () => {
    if (!element.classList.contains('is-enable')) {
      errorElement.classList.add('is-active');
    } else {
      element.classList.add('is-active');
    }
  });
});
